'use client';

import { useEffect, useRef, useState } from 'react';

/**
 * Pins the navigation row once the page has scrolled past it, and reports the
 * row height so the layout can reserve the space the row vacates.
 */
export const useStickyNav = () => {
  const navRowRef = useRef<HTMLDivElement | null>(null);
  const [isPinned, setIsPinned] = useState(false);
  const [navRowHeight, setNavRowHeight] = useState(0);

  useEffect(() => {
    const trigger = document.getElementById('sticky-trigger');
    if (!trigger) return;

    const observer = new IntersectionObserver(
      ([entry]) => setIsPinned(!entry.isIntersecting),
      { root: null, threshold: 0 },
    );

    observer.observe(trigger);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (navRowRef.current) {
      setNavRowHeight(navRowRef.current.offsetHeight);
    }
  }, [isPinned]);

  return { navRowRef, isPinned, navRowHeight };
};
